import React, { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import {
  UIStateProvider,
  AccountProvider,
  PlayerStateProvider,
  PlayerQueueProvider,
  SocketStateProvider,
  UIStateContext,
} from "./provider";
import { Library, Auth, Server } from "./module";
import ElectronHead from "./module/electron-head";
import Connectors from "./connectors";
import Player from "./module/player";
import Navigation from "./module/navigation";
import IntroModule from "./module/intro";
import ConfigModule from "./module/configure";
import AccountModule from "./module/account";
import ImportModule from "./module/import";
// import Momo from "../momo";

import { NAVBAR, PLAYER_CONTROLS } from "./theme/dimensions";
import { COLORSCHEME } from "./theme/color";
import { Z_INDEX, SCREEN_TYPE } from "./constants";
import { IS_ELECTRON_APP } from "./config";

// will be fixed on left side always : height=full, width=two kinds
const HeadWrapper = styled.div`
  width: 100vw;
  height: 5vh;
  position: fixed;
  top: 0px;
  left: 0px;
  background-color: #fff;
  box-sizing: border-box;
  z-index: ${Z_INDEX.electronHead};
`;

// will be fixed on left side always : height=full, width=two kinds
const NavigationWrapper = styled.div`
  width: auto;
  height: auto;
  position: fixed;
  top: ${IS_ELECTRON_APP ? "5vh" : `0px`};
  left: 0px;
  background-color: #fff;
  box-sizing: border-box;
  z-index: ${Z_INDEX.navbar};
  /* display: block; */
`;

// will be in center,
const MomoWrapper = styled.div`
  width: ${({ isNavMin, isMobileScreen }) =>
    isMobileScreen || isNavMin
      ? `100%`
      : `calc(100% - ${NAVBAR.SIDE_WIDTH}px)`};
  height: calc(
    ${IS_ELECTRON_APP ? "95vh" : "100vh"} - ${PLAYER_CONTROLS.HEIGHT}px
  );
  position: fixed;
  top: ${IS_ELECTRON_APP ? "5vh" : `0px`};
  left: ${({ isNavMin, isMobileScreen }) =>
    isMobileScreen ? 0 : isNavMin ? 0 : NAVBAR.SIDE_WIDTH}px;
  z-index: ${Z_INDEX.momo};
  box-sizing: border-box;
  overflow: hidden;
  background-color: ${COLORSCHEME.BLACK_0};
`;

const App = () => {
  const [UIState, setUIState] = useContext(UIStateContext);
  const { screen } = UIState;
  const isMobileScreen = screen === SCREEN_TYPE.MOBILE;
  const [isNavMin, setIsNavMin] = useState(isMobileScreen);

  useEffect(() => {
    const screenChanged = screen === SCREEN_TYPE.MOBILE;
    setIsNavMin(screenChanged);
  }, [screen]);

  return (
    <div>
      {IS_ELECTRON_APP && (
        <HeadWrapper>
          <ElectronHead />
        </HeadWrapper>
      )}
      <NavigationWrapper>
        <Navigation isNavMin={isNavMin} setIsNavMin={setIsNavMin} />
      </NavigationWrapper>
      <MomoWrapper isNavMin={isNavMin} isMobileScreen={isMobileScreen}>
        <Switch>
          <Route path="/" exact component={IntroModule} />
          <Route path="/profile" exact component={AccountModule} />
          <Route path="/import" exact component={ImportModule} />
          <Route
            path="/playlist/:id"
            exact
            component={Library.PlaylistItemModule}
          />
          <Route path="/playlists" exact component={Library.PlaylistsModule} />
          <Route path="/rooms" exact component={Server.RoomsModule} />
          <Route path="/room/:id" exact component={Server.RoomModule} />
          <Route path="/config" exact component={ConfigModule} />
          <Route path="/account" exact component={AccountModule} />
          <Route path="/intro" component={IntroModule} />
          <Redirect from="/" to="intro" />
        </Switch>
      </MomoWrapper>
      <Player />
    </div>
  );
};

export default function () {
  return (
    <Router>
      <AccountProvider>
        <SocketStateProvider>
          <UIStateProvider>
            <PlayerStateProvider>
              <PlayerQueueProvider>
                <Switch>
                  <Route path="/auth" exact component={Auth.GuestModule} />
                  <Route path="/" component={App} />
                </Switch>
                <Connectors />
              </PlayerQueueProvider>
            </PlayerStateProvider>
          </UIStateProvider>
        </SocketStateProvider>
      </AccountProvider>
    </Router>
  );
}
